import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Link } from "react-router-dom";

import { IconMenuItem } from "@/Components/v2/atoms/MenuItem";
import BetaPill from "@/Components/v2/atoms/Pill/BetaPill";
import { LinkType } from "@/Components/v2/constants/enum";

export interface DrawerMenuItemProps {
  label: string;
  route: string;
  onClick?: (() => void) | undefined;
  hasAccess: boolean;
  isBeta?: boolean;
  type?: LinkType;
  icon?: React.ReactNode;
  selected?: boolean;
}

export const DrawerMenuItem: React.FC<DrawerMenuItemProps> = ({
  label,
  route,
  onClick,
  hasAccess,
  isBeta,
  type,
  icon,
  selected,
}) => {
  switch (type) {
    case LinkType.External:
      return (
        <a
          href={route}
          style={{ textDecoration: "none", color: "inherit" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <IconMenuItem icon={icon} onClick={onClick} disabled={!hasAccess}>
            {label} {isBeta && <BetaPill />}{" "}
            {<OpenInNewIcon fontSize="small" sx={{ marginLeft: "8px" }} />}
          </IconMenuItem>
        </a>
      );
    case LinkType.Internal:
      return (
        <Link to={route} style={{ textDecoration: "none", color: "inherit" }}>
          <IconMenuItem icon={icon} onClick={onClick} disabled={!hasAccess} selected={!!selected}>
            {label} {isBeta && <BetaPill />}
          </IconMenuItem>
        </Link>
      );
    default:
      return null;
  }
};

export default DrawerMenuItem;
